export const environment = {
  production: false,
  envName: 'development',
  apiUrl: 'https://api.cc-irdigital.pe/integracion/cc-auth-svc/api/v1',
  apiPublicUrl: 'https://api.cc-irdigital.pe/public/cc-auth-svc/api/v1',
  defaultProductCode: 'AUTH',
  firebase: {
    apiKey: 'AIzaSyA8pameJ4hr7sAQ3yOYbezTizVfmrhSQUk',  // Reemplaza con tu Firebase API key
    authDomain: 'pe-gcp-customercare-02.firebaseapp.com',  // Reemplaza con tu Auth domain
    projectId: 'pe-gcp-customercare-02',  // Reemplaza con tu Project ID
    storageBucket: 'customer-care-auth.appspot.com',  // Reemplaza con tu Storage Bucket
    messagingSenderId: '52415902569_',  // Reemplaza con tu sender ID
    appId: '1:52415902569:web:c080b833159bb3d72743f8_'  // Reemplaza con tu app ID
  },
  firebaseProvider: {
    name: 'microsoft.com2',
    prompt: "consent",
    tenant: "5daabe65-ff53-4336-a448-2f61ecf0b059",
    authority: 'https://login.microsoftonline.com/common',
    scope: 'mail.read'
  }
};
